module.exports = __webpack_public_path__ + "img/编组 5@2x.86d57a81.png";